<section *ngIf="hasPermission()" class="main">
    <div class="header-wrapper">
        <div class="title-wrapper">
            <h2 class="main-title">Customer number details {{ customerNumber() }}</h2>
            <div class="back-button-container">
                <button class="btn-back" (click)="goBack()">
                    <i class="bi bi-arrow-left"></i>
                    <span>Back</span>
                </button>
            </div>
        </div>

        <div *ngIf="emailNotificationsService.customerDetails().length > 0" class="table-container">
            <table>
                <tr class="header">
                    <th>Transaction ID</th>
                    <th>Email Type</th>
                    <th>Sent At</th>
                    <th>Total Emails Sent</th>
                    <th>Requested Modifications</th>
                    <th>Same Modifications Requested</th>
                </tr>

                <tr *ngFor="let detail of emailNotificationsService.customerDetails(); trackBy: trackByTransactionId"
                    class="body-columns">
                    <td class="transaction-id" (click)="navigateToTransactionById(detail.transactionId)">
                        {{ detail.transactionId }}
                    </td>
                    <td>{{ detail.emailTypeDisplayName }}</td>
                    <td>{{ detail.sentAt }}</td>
                    <td>{{ detail.totalEmailsSent }}</td>
                    <td>{{ detail.requestedModifications }}</td>
                    <td>{{ detail.sameModificationCount}}</td>
                </tr>
            </table>
        </div>

        <div *ngIf="!emailNotificationsService.isCustomerDetailsLoading() && emailNotificationsService.customerDetails().length === 0"
             class="no-data">
            No email notifications found for this customer in the selected period.
        </div>
    </div>
</section>

<div *ngIf="!hasPermission()" class="no-data">
    Access denied. You don't have permission to view this page.
</div>
